import React from 'react';
import PropTypes from 'prop-types';

import GuideLineCard from './guideLineCard';

const DocSection = props => {
  const { docData = [] } = props;

  return (
    <div className="margin-t-30">
      <h2
        id={docData.heading}
        className={`doc-guidelines-heading ${
          docData.heading === 'Photo Identity' ? 'margin-t-30' : 'margin-t-40'
        }`}
      >
        {docData.heading}
      </h2>
      {/* <h4 className="doc-guidelines-subheading">{docData.subHeading}</h4> */}
      <GuideLineCard cardData={docData.card} />
    </div>
  );
};

DocSection.propTypes = {
  docData: PropTypes.array,
};

export default DocSection;
